import { render, staticRenderFns } from "./SelectCongregazione.vue?vue&type=template&id=2b56bfe8&scoped=true&"
import script from "./SelectCongregazione.vue?vue&type=script&lang=js&"
export * from "./SelectCongregazione.vue?vue&type=script&lang=js&"
import style0 from "./SelectCongregazione.vue?vue&type=style&index=0&id=2b56bfe8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b56bfe8",
  null
  
)

export default component.exports